import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Get only the gallery-specific images (not hero/about)
  const displayImages = galleryImages.filter(img => 
    img.category !== 'about'
  );

  return (
    <section id="galeria" className="section-padding bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="hero-subtitle text-[#666] mb-4">
            Portfolio
          </p>
          <h2 className="section-title text-[#333] mb-6">
            Mi trabajo
          </h2>
          <p className="body-large text-[#666] max-w-2xl mx-auto">
            Una selección de mis trabajos de maquillaje y peinado para novias y eventos especiales.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {displayImages.map((image) => (
            <div
              key={image.id}
              className="relative aspect-square overflow-hidden cursor-pointer group"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div 
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors"
              aria-label="Cerrar"
            >
              <X size={32} strokeWidth={1.5} />
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[85vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default GallerySection;
